import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bookingPolicy = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _countBookingPoliciesRequest = {};
var _countBookingPoliciesResponse = {};
var _createBookingPolicyRequest = { bookingPolicy: '_bookingPolicy' };
var _createBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _deleteBookingPolicyRequest = {};
var _deleteBookingPolicyResponse = {};
var _getBookingPolicyRequest = {};
var _getBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _getPolicyRequest = {};
var _getPolicyResponse = {};
var _getStrictestBookingPolicyRequest = {};
var _getStrictestBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _queryBookingPoliciesRequest = {};
var _queryBookingPoliciesResponse = { bookingPolicies: '_bookingPolicy' };
var _setDefaultBookingPolicyRequest = {};
var _setDefaultBookingPolicyResponse = {
    currentDefaultBookingPolicy: '_bookingPolicy',
    previousDefaultBookingPolicy: '_bookingPolicy',
};
var _updateBookingPolicyRequest = {
    mask: 'google.protobuf.FieldMask',
    bookingPolicy: '_bookingPolicy',
};
var _updateBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _updatePolicyRequest = {};
var _updatePolicyResponse = {};
function resolveWixBookingsV1BookingPoliciesServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/booking-policies',
                destPath: '/v1/booking-policies',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/booking-policies',
                destPath: '/v1/booking-policies',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v1/booking-policies/strictest',
                destPath: '/v1/booking-policies/strictest',
            },
            {
                srcPath: '/_api/bookings/v1/booking-policies/query',
                destPath: '/v1/booking-policies/query',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsServicesApiV1ServicesPolicyServiceUrl(opts) {
    var domainToMappings = {
        'bookings._base_domain_': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
        ],
        _api_base_domain_: [
            {
                srcPath: '/services-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/services-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/bookings/v1/forms',
                destPath: '/v1/forms',
            },
            {
                srcPath: '/bookings/v1/services',
                destPath: '/v1/services',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/forms',
                destPath: '/v1/forms',
            },
            {
                srcPath: '/_api/bookings/v1/services/batch',
                destPath: '/v1/services/batch',
            },
            {
                srcPath: '/_api/bookings/v1/batch/categories',
                destPath: '/v1/batch/categories',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/bookings/v1/services',
                destPath: '/v1/services',
            },
            {
                srcPath: '/_api/bookings/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/internal/services-server',
                destPath: '/internal',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/services-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/bookings/v1/forms',
                destPath: '/v1/forms',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function get(payload) {
    var _a = serializer(_getPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPolicyResponse, {}).fromJSON;
    function __get(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.services.api.v1.ServicesPolicyService.Get',
            url: resolveComWixpressBookingsServicesApiV1ServicesPolicyServiceUrl({
                protoPath: '/v1/services/policy',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __get.fromReq = fromReq;
    __get.__isAmbassador = true;
    return __get;
}
export function update(payload) {
    var _a = serializer(_updatePolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePolicyResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'PUT',
            methodFqn: 'com.wixpress.bookings.services.api.v1.ServicesPolicyService.Update',
            url: resolveComWixpressBookingsServicesApiV1ServicesPolicyServiceUrl({
                protoPath: '/v1/services/policy',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Creates a new booking policy. */
export function createBookingPolicy(payload) {
    var _a = serializer(_createBookingPolicyRequest, { _bookingPolicy: _bookingPolicy }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __createBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.CreateBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBookingPolicy.fromReq = fromReq;
    __createBookingPolicy.__isAmbassador = true;
    return __createBookingPolicy;
}
/** Retrieves booking policy by ID. */
export function getBookingPolicy(payload) {
    var _a = serializer(_getBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __getBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'GET',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.GetBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBookingPolicy.fromReq = fromReq;
    __getBookingPolicy.__isAmbassador = true;
    return __getBookingPolicy;
}
/**
 * Retrieves the strictest rules between a set of Booking Policies.
 *
 * This endpoint checks each rule of the given Booking Policies for the most strict option and and returns a booking policy consisting of the most strict option for each rule.
 * The Booking Policy Object returned is not created, it does not have an `id` and their information is not stored.
 * You can call (Create Booking Policy)[https://dev.wix.com/docs/rest/api-reference/wix-bookings/services/booking-policy/create-booking-policy] with that object information to create it.
 */
export function getStrictestBookingPolicy(payload) {
    var _a = serializer(_getStrictestBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStrictestBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __getStrictestBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.GetStrictestBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/strictest',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStrictestBookingPolicy.fromReq = fromReq;
    __getStrictestBookingPolicy.__isAmbassador = true;
    return __getStrictestBookingPolicy;
}
/**
 * Update a booking policy, supports partial update.
 * Each time the booking policy is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the booking policy.
 * This ensures you're working with the latest booking policy and prevents unintended overwrites.
 */
export function updateBookingPolicy(payload) {
    var _a = serializer(_updateBookingPolicyRequest, { _bookingPolicy: _bookingPolicy }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __updateBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'PATCH',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.UpdateBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicy.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBookingPolicy.fromReq = fromReq;
    __updateBookingPolicy.__isAmbassador = true;
    return __updateBookingPolicy;
}
/**
 * Sets a Booking Policy as default.
 *
 * Only one policy can be the default, calling this endpoint also sets the current default booking policy as non-default.
 * If the Booking Policy is already the default, the call will succeed without any updates.
 */
export function setDefaultBookingPolicy(payload) {
    var _a = serializer(_setDefaultBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setDefaultBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __setDefaultBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.SetDefaultBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicyId}:setDefault',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setDefaultBookingPolicy.fromReq = fromReq;
    __setDefaultBookingPolicy.__isAmbassador = true;
    return __setDefaultBookingPolicy;
}
/**
 * Deletes a Booking Policy.
 *
 * The default Booking policy cannot be deleted, to delete it, another Booking Policy must be (set as default)[https://dev.wix.com/docs/rest/api-reference/wix-bookings/services/booking-policy/set-default-booking-policy].
 */
export function deleteBookingPolicy(payload) {
    var _a = serializer(_deleteBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBookingPolicyResponse, {}).fromJSON;
    function __deleteBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'DELETE',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.DeleteBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBookingPolicy.fromReq = fromReq;
    __deleteBookingPolicy.__isAmbassador = true;
    return __deleteBookingPolicy;
}
/**
 * Retrieves a list of booking policies, given the provided paging, filtering, and sorting.
 *
 *
 * Query Booking Policies runs with these defaults, which you can override:
 *
 * - `createdDate` is sorted in `{{DESC,ASC}}` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `100`
 *
 * For field support for filters and sorting,
 * see Booking Policies: Supported Filters and Sorting](link/to/article).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryBookingPolicies(payload) {
    var _a = serializer(_queryBookingPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBookingPoliciesResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __queryBookingPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.QueryBookingPolicies',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBookingPolicies.fromReq = fromReq;
    __queryBookingPolicies.__isAmbassador = true;
    return __queryBookingPolicies;
}
/** Counts booking policies, given the provided filtering. */
export function countBookingPolicies(payload) {
    var _a = serializer(_countBookingPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countBookingPoliciesResponse, {}).fromJSON;
    function __countBookingPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.CountBookingPolicies',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countBookingPolicies.fromReq = fromReq;
    __countBookingPolicies.__isAmbassador = true;
    return __countBookingPolicies;
}
//# sourceMappingURL=http.impl.js.map